import styles from './PtinRequiredView.module.css'
import {
  EmptyState,
  EmptyStateActions,
  EmptyStateDescription,
  EmptyStateIllustration,
  EmptyStateTitle,
} from '@/components/EmptyState'
import { externalLinks } from '@/utils/link'
import { Button } from '@/components/Button'
import { byDesign } from '@/infra/design'
import imgIdUrl from '@/assets/misc/img_id.svg'
import PortalOverviewProfileIllustration from '@/components/SpotIllustration/PortalOverviewProfileIllustration'

export interface PtinRequiredViewProps {
  /**
   * Hides the illustration, for workspaces in corporate mode.
   */
  corporateMode: boolean
}

export function PtinRequiredView({ corporateMode }: PtinRequiredViewProps) {
  return (
    <div>
      <div className={styles.box}>
        <EmptyState pad>
          {!corporateMode && (
            <EmptyStateIllustration
              small
              src={imgIdUrl}
              illustration={byDesign(
                undefined,
                PortalOverviewProfileIllustration,
              )}
            />
          )}
          <EmptyStateTitle>New year, new PTIN required!</EmptyStateTitle>
          <EmptyStateDescription>
            Renew your PTIN to unlock this page. Without your updated{' '}
            {new Date().getFullYear()} PTIN, you won't be able to pick up or
            work on any jobs. Upon submission it might take up to 48 hours to
            regain access.
          </EmptyStateDescription>
          <EmptyStateActions>
            <Button
              label="Update My Credentials"
              variant="primary"
              href={externalLinks.ptinRenewal()}
              target={'_blank'}
            />
          </EmptyStateActions>
        </EmptyState>
      </div>
    </div>
  )
}
